import { render } from "./NewAccount.vue?vue&type=template&id=a213ec14&scoped=true"
import script from "./NewAccount.vue?vue&type=script&lang=js"
export * from "./NewAccount.vue?vue&type=script&lang=js"

import "./NewAccount.vue?vue&type=style&index=0&id=a213ec14&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a213ec14"]])

export default __exports__